import stampit from 'stampit';
const Reference = stampit({
  props: {
    uri: '',
    value: null,
    depth: 0,
    refSet: null,
    errors: []
  },
  init() {
    let {
      depth = this.depth,
      refSet = this.refSet,
      uri = this.uri,
      value = this.value
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.uri = uri;
    this.value = value;
    this.depth = depth;
    this.refSet = refSet;
    this.errors = [];
  }
});
export default Reference;